// One Time Messages
export const NEW_USER_SPOTLIGHT_TOUR_MESSAGE_ID = 'new-user-spotlight-tour';
export const PREMIUM_TRIAL_MODAL_MESSAGE_DISMISSED_KEY_PREFIX =
  'premium-trial-modal-message-dismissed-for-ws';
export const ISLAND_NAV_SPOTLIGHT_MESSAGE_ID = 'island-nav-spotlight-tour';
export const BOARD_SWITCHER_SPOTLIGHT_MESSAGE_ID = 'board-switcher-spotlight';

// Prefix to identify the onboarding list
export const NEW_USER_ONBOARDING_LIST_PREFIX = 'getting-started-list';
export const NEW_USER_DEFAULT_BOARD_PREFIX = 'default-board';

// Spotlight Targets
export const PANEL_NAVIGATION_SPOTLIGHT = 'panel-navigation-spotlight';
export const INBOX_SPOTLIGHT = 'inbox-spotlight';
export const ONBOARDING_LIST_SPOTLIGHT = 'onboarding-list-spotlight';
export const BOARD_SWITCHER_SPOTLIGHT = 'board-switcher-spotlight';

// Spotlight Targets radii
export const PANEL_NAVIGATION_SPOTLIGHT_RADIUS = 12;
export const ONBOARDING_LIST_SPOTLIGHT_RADIUS = 12;
export const INBOX_SPOTLIGHT_RADIUS = 16;
export const BOARD_SWITCHER_SPOTLIGHT_RADIUS = 16;

// Spotlight Width
export const SPOTLIGHT_WIDTH = 275;
